export default __webpack_public_path__ + "static/media/Paragliding1.e86a9ef6.mp4";